// extracted by mini-css-extract-plugin
export default {"button":"GuideButton_button__H1fVv"};